import axiosInstance from "../axiosInstance";

export const GETCenope = async (loggedUser) => {
  try {
    const { id } = loggedUser;
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_WMS_BASE_URL}/permisos/getCenope?idusua=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    // Errores de red u otros
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETCenope;
